<div class="stepper-content">

    <div class="stepper-header d-flex align-items-center justify-content-start flex-wrap">
        <div class="container_ d-flex align-items-center justify-content-start flex-wrap">
            <ng-container *ngFor="let section of sections; index as i, last as last;">
                <ng-container *ngIf="!section.stepHidden">
                    <button
                        [class.enabled]="activeSection === i || !section.isCanActivate"
                        [class.active]="activeSection === i"
                        [class.valid]="i < activeSection"

                        class="d-flex align-items-center justify-content-flex-start flex-wrap">

                        <div class="icon-wrp">
                            <i class="{{section.icon}}"></i><i *ngIf="i < activeSection" class="icon-tick"></i>
                        </div>
                        <span>{{ section.title }}</span>
                        <span *ngIf="i < isLastStep" class="arrow-right icon-right"></span>
                    </button>
                </ng-container>
            </ng-container>

        </div>
    </div>

    <div class="container_">
        <ng-container *ngFor="let section of sections">
            <ng-container *ngIf="!section.hidden" [ngTemplateOutlet]="section.templateRef"></ng-container>
        </ng-container>
    </div>
</div>
